module.exports = __webpack_public_path__ + "static/media/IconPasswordOn.2023609b.svg";